export const GPTStatus: {
  [key: string]: {
    text: string;
    color: string;
  };
} = {
  init: {
    text: 'In queue',
    color: '#326FF0',
  },
  inqueue: {
    text: 'In queue',
    color: '#326FF0',
  },
  running: {
    text: 'Generating',
    color: '#326FF0',
  },
  callback_success: {
    text: 'In queue',
    color: '#326FF0',
  },
  // 调用gpt 服务成功
  api_send_success: {
    text: 'In queue',
    color: '#326FF0',
  },
  retry: {
    text: 'In queue',
    color: '#326FF0',
  },
  success: {
    text: 'Done',
    color: '#69D19C',
  },
  finish: {
    text: 'Done',
    color: '#69D19C',
  },
  failed: {
    text: 'Summary failed',
    color: '#EF5858',
  },
  // 调佣gpt 服务失败
  api_send_fail: {
    text: 'Summary failed',
    color: '#EF5858',
  },
  // 调佣gpt 服务失败
  callback_failed: {
    text: 'Summary failed',
    color: '#EF5858',
  },
  nodata: {
    text: 'No data',
    color: '#EF5858',
  },
  crawling_failed: {
    text: 'Crawling failed',
    color: '#EF5858',
  },
  ai_tagging: {
    text: 'AI Tagging',
    color: '#326FF0',
  },
  complete_without_summary: {
    text: 'Done',
    color: '#69D19C',
  },
  tagging_failed: {
    text: 'Tagging failed',
    color: '#EF5858',
  },
  stopped: {
    text: 'Stopped',
    color: '#999999',
  },
  no_new_data: {
    text: 'No New Data',
    color: '#999999',
  },
};

export const GPTStatusEmptyText: {
  [key: string]: string;
} = {
  'In queue':
    'The AI summary task is in the queue, and the report content has not been generated yet.',
  Generating:
    'The AI summary is being generated and is expected to take 1 to 3 hours, depending on the content.',
  'Summary failed':
    `We couldn't generate the AI summary for this content. Please contact {contact} for help.`,
};
